import { caraPembayaranMeta } from "../../data/DataMetatags";
import { defBreadcrumb } from "../../data/DataBreadcrumb";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { caraPembayaranBreadcrumb } from "../../data/DataBreadcrumb";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import PaymentBlocks from "../../components/Payment/PaymentBlocks";
import { useEffect } from "react";
import { GACustomEvent } from "src/utils/analytics";

const CaraPembayaran = (props) => {
  const {
    breadcrumb,
    caraPembayaranBreadcrumb,
    title,
    description,
    path
  } = props;

 useEffect(() => {
   GACustomEvent("payment_methods_page", "view");
 }, []);
 
  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={caraPembayaranBreadcrumb} />
      <HeadingComponent headingText="Metode Pembayaran Home Credit " />
      <PaymentBlocks />
    </Layout>
  );
};

export const getStaticProps = () => {
  const { title, description, path } = caraPembayaranMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      breadcrumb,
      caraPembayaranBreadcrumb,
      title,
      description,
      path
    }
  };
};

export default CaraPembayaran;
